<template>
  <main class="container">
    <div class="row">
      <div class="col s12 center-align">
        <h1 class="titulo">Galeria</h1>
      </div>
    </div>
    <div class="row galeria">
      <div class="col s12 m4 l3">
        <div class="material-placeholder" id="element">
          <img
            src="../assets/img/1.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/2.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/3.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/4.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/5.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/6.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/7.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
      <div class="col s12 m4 l3">
        <div class="material-placeholder">
          <img
            src="../assets/img/8.jpg"
            alt=""
            class="responsive-img materialboxed"
            data-caption="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
          />
        </div>
      </div>
    </div>
  </main>
  
  

</template>

<script>
  export default{
    methods:{
      
    }
  }

</script>

<style></style>
